import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/About',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/client',
    name: 'Client',
    component: () => import(/* webpackChunkName: "client" */ '../views/Client.vue')
  },
  {
    path: '/Team',
    name: 'Team',
    component: () => import(/* webpackChunkName: "team" */ '../views/Team.vue')
  },
  {
    path: '/apple',
    name: 'Apple',
    component: () => import(/* webpackChunkName: "apple" */ '../views/Apple.vue')
  },
  {
    path: '/media',
    name: 'Media',
    component: () => import(/* webpackChunkName: "media" */ '../views/News.vue')
  },
  {
    path: '/awards',
    name: 'Awards',
    component: () => import(/* webpackChunkName: "awards" */ '../views/Awards.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue')
  },
  {
    path: '/live-video',
    name: 'LiveVideo',
    component: () => import(/* webpackChunkName: "live-demo" */ '../views/LiveVideo.vue')
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import(/* webpackChunkName: "contacts" */ '../views/Contacts.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
